import {rangeText, numFormat, getDiffDays} from "./util";
import {stockToSymbol} from "./stock";

export {
	courseCalendarTemplateData
};

function courseCalendarTemplateData(data) {
	const calendarHash = data.calendarHash;
	const prices = courseCalendarPriceFunc(data);
	const isHoliday = courseCalendarHolidayFunc(calendarHash);
	const stocks = courseCalendarStockFunc(data);
	const dataVersion = data.dataVersion;
	const hasData = (code) => {
		return !!calendarHash[code] &&
			calendarHash[code].index >= data.startDateIndex;
	};
	const isSelectable = (code) => {
		const normalCond = hasData(code) && +stocks(code).stock >= 0 && prices(code);
		const noStockInfoCond = getDiffDays(dataVersion, code, "courseCal") >= 280
			&& hasData(code)
			&& (+stocks(code).stock === -2 || !stocks(code).stock)
			&& prices(code); // JALINTL-611 出発日が280日以降は在庫設定なし(-2)でも詳細画面へのリンクを有効化
		return normalCond || noStockInfoCond;
	};
	const saikoIndexes = courseCalendarSaikoFunc(data);
	const withTourConductor = data.withTourConductor;
	return { stocks, prices, hasData, isHoliday, isSelectable, saikoIndexes, withTourConductor };
}

function courseCalendarPriceFunc(data) {
	return (code) => {
		if (!data.calendarHash[code]) return null;
		const min = data.minPrices[data.calendarHash[code].index] || 0;
		const max = data.maxPrices[data.calendarHash[code].index] || 0;
		if (+min === 0 && +max === 0) return null;
		return rangeText(numFormat(min), numFormat(max));
	};
}

function courseCalendarHolidayFunc(calendarHash) {
	return (code) => {
		return calendarHash[code] ? calendarHash[code].holiday === "1" : false;
	};
}

function courseCalendarStockFunc(data) {
	return (code) => {
		const stock = data.calendarHash[code] ? data.stocks[data.calendarHash[code].index] : -1;
		const symbol = stockToSymbol(stock);
		return {
			stock,
			cls: symbol.cls,
			symbol: symbol.symbol
		};
	};
}

function courseCalendarSaikoFunc(data) {
	return (code) => {
		const saikoIndex = data.calendarHash[code] ? data.saikoIndexes[data.calendarHash[code].index] : -1;
		return saikoIndex;
	};
}



// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/modules/course-calendar.js